var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHqBaltic = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 665,
    height: 117,
    viewBox: "0 0 665 117",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D02629",
    d: "M35.7293191,48.1756355 C52.7008337,48.1756355 66.4585899,61.9024376 66.4585899,78.8357674 C66.4585899,95.7690971 52.7008337,109.495899 35.7293191,109.495899 C18.7578045,109.495899 5.00004826,95.7690971 5.00004826,78.8357674 C5.00004826,61.9024376 18.7578045,48.1756355 35.7293191,48.1756355"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D02629",
    strokeWidth: 2,
    d: "M35.7293191,43.3716047 C55.3599003,43.3716047 71.273292,59.2491922 71.273292,78.8356059 C71.273292,98.4220195 55.3599003,114.300145 35.7293191,114.300145 C16.0987378,114.300145 0.185346181,98.4220195 0.185346181,78.8356059 C0.185346181,59.2491922 16.0987378,43.3716047 35.7293191,43.3716047 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "33.207 77.516 35.513 60.711 51.406 95.992"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "40.97 86.065 19.356 95.992 34.39 58.519 29.793 86.446"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D02629",
    d: "M330.935361,48.1756355 C347.906875,48.1756355 361.664632,61.9024376 361.664632,78.8357674 C361.664632,95.7690971 347.906875,109.495899 330.935361,109.495899 C313.963846,109.495899 300.20609,95.7690971 300.20609,78.8357674 C300.20609,61.9024376 313.963846,48.1756355 330.935361,48.1756355"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D02629",
    strokeWidth: 2,
    d: "M330.935361,43.3716047 C350.565942,43.3716047 366.479334,59.2491922 366.479334,78.8356059 C366.479334,98.4220195 350.565942,114.300145 330.935361,114.300145 C311.30478,114.300145 295.391388,98.4220195 295.391388,78.8356059 C295.391388,59.2491922 311.30478,43.3716047 330.935361,43.3716047 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "328.413 77.516 330.719 60.711 346.612 95.992"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "336.176 86.065 314.562 95.992 329.596 58.519 324.999 86.446"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D02629",
    d: "M626.920669,48.1756355 C643.892183,48.1756355 657.64994,61.9024376 657.64994,78.8357674 C657.64994,95.7690971 643.892183,109.495899 626.920669,109.495899 C609.949154,109.495899 596.191398,95.7690971 596.191398,78.8357674 C596.191398,61.9024376 609.949154,48.1756355 626.920669,48.1756355"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D02629",
    strokeWidth: 2,
    d: "M626.920669,43.3716047 C646.55125,43.3716047 662.464642,59.2491922 662.464642,78.8356059 C662.464642,98.4220195 646.55125,114.300145 626.920669,114.300145 C607.290087,114.300145 591.376696,98.4220195 591.376696,78.8356059 C591.376696,59.2491922 607.290087,43.3716047 626.920669,43.3716047 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "624.398 77.516 626.705 60.711 642.598 95.992"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "632.161 86.065 610.548 95.992 625.581 58.519 620.984 86.446"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D02629",
    strokeWidth: 2,
    d: "M35.7293191,43.3716047 C35.8701503,43.2703912 36.780967,42.6281167 38.4137462,41.5707594"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D02629",
    strokeDasharray: "12.026 12.026",
    strokeWidth: 2,
    d: "M43.9268849,38.1593823 C75.0543683,19.6750106 190.79931,-37.4524331 325.354127,40.0840525"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D02629",
    strokeWidth: 2,
    d: "M328.155266 41.7162267C329.081191 42.2615948 330.007655 42.8134234 330.935199 43.3717124M626.141402 43.3716047C626.000571 43.2703912 625.089755 42.6281167 623.456975 41.5707594"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D02629",
    strokeDasharray: "12.026 12.026",
    strokeWidth: 2,
    d: "M617.943837,38.1593823 C586.816353,19.6750106 471.071412,-37.4524331 336.516595,40.0840525"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D02629",
    strokeWidth: 2,
    d: "M333.715456,41.7162267 C332.789531,42.2615948 331.863066,42.8134234 330.935523,43.3717124"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHqBaltic, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hq_baltic.59d1fc88.svg";
export { ForwardRef as ReactComponent };